import axios from 'axios';
import { Toast } from 'antd-mobile';

axios.defaults.headers.post['Content-Type'] = 'application/json';
const _axios = axios.create({
  baseURL: '/',
  timeout: 5 * 60 * 1000, // 5min
  withCredentials: true,
  responseType: 'json',
  'Content-Type': 'application/json',
  type: 'post',
  method: 'post',
  notify: true, // 可手动设置不提示
})
_axios.interceptors.request.use(
  function (config) {
    if (config.method === 'get') {
      config.params = config.data
    }

    // 本地运行才需要配置url前缀
    // baseURL默认未`/${ app }`
    // 使用type参数来区分(工资贷/tifi 小贷/loan)
    if (config.type === 'tifi') {
      config.url = `/tifi${ config.url }`;
    } else if (config.type === 'tifi_slice') {
      config.url = `${ config.url }`;
    } else {
      config.url = `/loan${ config.url }`;
    }

    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)
// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    const { data, config } = response;
    const { responseType, notify } = config;

    if (response.status === 200) {
      if (responseType === 'arraybuffer') return data;

      if (data && data.code === '0000') {
        return data.data
      } else {
        notify && Toast.fail(data.msg, 2);
        return Promise.reject(data)
      }
    } else {
      notify && Toast.fail('Get data exception', 2);
      return Promise.reject(new Error('status not 200!'))
    }
  },
  function (error) {
    error.config.notify && Toast.fail('Get data exception', 2);
    return Promise.reject(error)
  }
)

const $proxy = (opt) => {
  return _axios({
    notify: true,
    ...opt
  })
}

export default $proxy;
